import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// 年龄门：16+ 才能观看。首次访问需确认，确认后本地记住 30 天。
export const AGE_KEY = 'digilok.ageGate'
export const MIN_AGE = 16
const VALID_DAYS = 30

function readVerified() {
  try {
    const raw = localStorage.getItem(AGE_KEY)
    if (!raw) return false
    const at = Number(raw)
    if (!at || Number.isNaN(at)) return false
    return Date.now() - at < VALID_DAYS * 24 * 60 * 60 * 1000
  } catch (e) {
    return false
  }
}

export const useAgeGateStore = defineStore('ageGate', () => {
  const verified = ref(readVerified())
  const declined = ref(false)

  // 需要展示年龄门
  const required = computed(() => !verified.value)
  // 被拒绝后整站锁死（不给绕过入口，只给「我点错了」回退）
  const blocked = computed(() => declined.value)

  function confirmAge() {
    declined.value = false
    verified.value = true
    try { localStorage.setItem(AGE_KEY, String(Date.now())) } catch (e) { /* 隐私模式忽略 */ }
  }

  function declineAge() {
    declined.value = true
  }

  function resetDecline() {
    declined.value = false
  }

  return { verified, declined, required, blocked, confirmAge, declineAge, resetDecline }
})
